import {
	CURRENT_DAYS,
	CURRENT_MONTH,
	CURRENT_QUARTER,
	CURRENT_WEEK,
	CURRENT_YEAR,
} from "helpers/temporal"
import { isIn } from "components/Transactional/Performance/utils/utils"
import { CustomerProfilingTimeline } from "components/CustomerBehavior/CustomerProfiling/service"
import { COLOR_PALETTE } from "colors"

export interface DataNode {
	date: string
	[key: string]: any
}

export interface FormatProps {
	dataKey: string
	[key: string]: any
}

export const DAILY_INTERVAL = "daily"
export const WEEKLY_INTERVAL = "weekly"
export const MONTHLY_INTERVAL = "monthly"

export const chipsAvailable = (period: string): Record<string, boolean> => ({
	[DAILY_INTERVAL]: isIn(period, [
		CURRENT_DAYS,
		CURRENT_MONTH,
		CURRENT_QUARTER,
		CURRENT_WEEK,
	]),
	[WEEKLY_INTERVAL]: isIn(period, [
		CURRENT_MONTH,
		CURRENT_QUARTER,
		CURRENT_YEAR,
		CURRENT_WEEK,
	]),
	[MONTHLY_INTERVAL]: isIn(period, [CURRENT_QUARTER, CURRENT_YEAR]),
})

export const CHIP_TRANSLATIONS = [
	{
		interval: DAILY_INTERVAL,
		id: "phronesis.timeline.daily.option",
	},
	{
		interval: WEEKLY_INTERVAL,
		id: "phronesis.timeline.weekly.option",
	},
	{
		interval: MONTHLY_INTERVAL,
		id: "phronesis.timeline.monthly.option",
	},
]

export const formatHabits: FormatProps[] = [
	{
		dataKey: "flexible",
		stroke: COLOR_PALETTE.YELLOW_600,
	},
	{
		dataKey: "demanding",
		stroke: COLOR_PALETTE.CHART_3,
	},
	{
		dataKey: "optimizer",
		stroke: COLOR_PALETTE.CHART_2,
	},
	{
		dataKey: "spontaneous",
		stroke: COLOR_PALETTE.PURPLE_500,
	},
]

export const formatGender: FormatProps[] = [
	{
		dataKey: "male",
		stroke: COLOR_PALETTE.PURPLE_500,
	},
	{
		dataKey: "female",
		stroke: COLOR_PALETTE.CHART_2,
	},
	{
		dataKey: "other",
		stroke: COLOR_PALETTE.YELLOW_600,
	},
]

export const formatAge: FormatProps[] = [
	{
		dataKey: "older65",
		stroke: COLOR_PALETTE.CHART_5,
	},
	{
		dataKey: "55to65",
		stroke: COLOR_PALETTE.CHART_4,
	},
	{
		dataKey: "45to54",
		stroke: COLOR_PALETTE.CHART_3,
	},
	{
		dataKey: "35to44",
		stroke: COLOR_PALETTE.YELLOW_600,
	},
	{
		dataKey: "25to34",
		stroke: COLOR_PALETTE.CHART_2,
	},
	{
		dataKey: "18to24",
		stroke: COLOR_PALETTE.PURPLE_500,
	},
]

export const data: CustomerProfilingTimeline = {
	interval: "weekly",
	metricName: "transactions",
	data: [
		{
			id: 1,
			date: "01/01/2023",
			flexible: 1,
			demanding: 0,
			optimizer: 8,
			spontaneous: 22,
		},
		{
			id: 2,
			date: "02/01/2023",
			flexible: 141837,
			demanding: 12658,
			optimizer: 609086,
			spontaneous: 1190976,
		},
		{
			id: 3,
			date: "09/01/2023",
			flexible: 134116,
			demanding: 11743,
			optimizer: 583075,
			spontaneous: 1160340,
		},
		{
			id: 4,
			date: "16/01/2023",
			flexible: 134062,
			demanding: 11890,
			optimizer: 585464,
			spontaneous: 1158201,
		},
		{
			id: 5,
			date: "23/01/2023",
			flexible: 136691,
			demanding: 12440,
			optimizer: 583533,
			spontaneous: 1140101,
		},
		{
			id: 6,
			date: "30/01/2023",
			flexible: 145368,
			demanding: 13150,
			optimizer: 616937,
			spontaneous: 1203693,
		},
		{
			id: 7,
			date: "06/02/2023",
			flexible: 132721,
			demanding: 11267,
			optimizer: 581365,
			spontaneous: 1160155,
		},
		{
			id: 8,
			date: "13/02/2023",
			flexible: 146847,
			demanding: 12143,
			optimizer: 667877,
			spontaneous: 1350908,
		},
		{
			id: 9,
			date: "20/02/2023",
			flexible: 151894,
			demanding: 13365,
			optimizer: 667560,
			spontaneous: 1342548,
		},
		{
			id: 10,
			date: "27/02/2023",
			flexible: 172276,
			demanding: 15262,
			optimizer: 739082,
			spontaneous: 1442382,
		},
		{
			id: 11,
			date: "06/03/2023",
			flexible: 145457,
			demanding: 11901,
			optimizer: 667702,
			spontaneous: 1357518,
		},
		{
			id: 12,
			date: "13/03/2023",
			flexible: 137001,
			demanding: 10710,
			optimizer: 633960,
			spontaneous: 1314255,
		},
		{
			id: 13,
			date: "20/03/2023",
			flexible: 137134,
			demanding: 11274,
			optimizer: 622618,
			spontaneous: 1267719,
		},
		{
			id: 14,
			date: "27/03/2023",
			flexible: 144481,
			demanding: 12328,
			optimizer: 635400,
			spontaneous: 1269166,
		},
		{
			id: 15,
			date: "03/04/2023",
			flexible: 141547,
			demanding: 11389,
			optimizer: 647255,
			spontaneous: 1304324,
		},
		{
			id: 16,
			date: "10/04/2023",
			flexible: 122597,
			demanding: 9554,
			optimizer: 571486,
			spontaneous: 1205390,
		},
		{
			id: 17,
			date: "17/04/2023",
			flexible: 126003,
			demanding: 10033,
			optimizer: 580786,
			spontaneous: 1211594,
		},
		{
			id: 18,
			date: "24/04/2023",
			flexible: 138395,
			demanding: 11791,
			optimizer: 609545,
			spontaneous: 1242908,
		},
		{
			id: 19,
			date: "01/05/2023",
			flexible: 115882,
			demanding: 9657,
			optimizer: 516931,
			spontaneous: 1071579,
		},
		{
			id: 20,
			date: "08/05/2023",
			flexible: 127896,
			demanding: 9887,
			optimizer: 596859,
			spontaneous: 1259173,
		},
		{
			id: 21,
			date: "15/05/2023",
			flexible: 122263,
			demanding: 9518,
			optimizer: 563294,
			spontaneous: 1202435,
		},
		{
			id: 22,
			date: "22/05/2023",
			flexible: 122650,
			demanding: 10227,
			optimizer: 559557,
			spontaneous: 1186207,
		},
		{
			id: 23,
			date: "29/05/2023",
			flexible: 145137,
			demanding: 13475,
			optimizer: 629651,
			spontaneous: 1299932,
		},
		{
			id: 24,
			date: "05/06/2023",
			flexible: 127977,
			demanding: 10813,
			optimizer: 575074,
			spontaneous: 1237411,
		},
		{
			id: 25,
			date: "12/06/2023",
			flexible: 124270,
			demanding: 10081,
			optimizer: 576480,
			spontaneous: 1247996,
		},
		{
			id: 26,
			date: "19/06/2023",
			flexible: 138998,
			demanding: 11814,
			optimizer: 643008,
			spontaneous: 1375960,
		},
		{
			id: 27,
			date: "26/06/2023",
			flexible: 143478,
			demanding: 13250,
			optimizer: 636089,
			spontaneous: 1397669,
		},
		{
			id: 28,
			date: "03/07/2023",
			flexible: 136956,
			demanding: 12432,
			optimizer: 609387,
			spontaneous: 1376026,
		},
		{
			id: 29,
			date: "10/07/2023",
			flexible: 127612,
			demanding: 10933,
			optimizer: 584311,
			spontaneous: 1328339,
		},
		{
			id: 30,
			date: "17/07/2023",
			flexible: 131052,
			demanding: 11222,
			optimizer: 587812,
			spontaneous: 1323984,
		},
		{
			id: 31,
			date: "24/07/2023",
			flexible: 133888,
			demanding: 12169,
			optimizer: 582493,
			spontaneous: 1292717,
		},
		{
			id: 32,
			date: "31/07/2023",
			flexible: 144130,
			demanding: 12951,
			optimizer: 628731,
			spontaneous: 1393865,
		},
		{
			id: 33,
			date: "07/08/2023",
			flexible: 123417,
			demanding: 10461,
			optimizer: 559802,
			spontaneous: 1295918,
		},
		{
			id: 34,
			date: "14/08/2023",
			flexible: 130478,
			demanding: 10698,
			optimizer: 588882,
			spontaneous: 1312641,
		},
		{
			id: 35,
			date: "21/08/2023",
			flexible: 126663,
			demanding: 11115,
			optimizer: 564618,
			spontaneous: 1277638,
		},
		{
			id: 36,
			date: "28/08/2023",
			flexible: 141253,
			demanding: 13353,
			optimizer: 605458,
			spontaneous: 1379838,
		},
		{
			id: 37,
			date: "04/09/2023",
			flexible: 133214,
			demanding: 12218,
			optimizer: 581906,
			spontaneous: 1360730,
		},
		{
			id: 38,
			date: "11/09/2023",
			flexible: 150142,
			demanding: 13481,
			optimizer: 651106,
			spontaneous: 1478194,
		},
		{
			id: 39,
			date: "18/09/2023",
			flexible: 94233,
			demanding: 8204,
			optimizer: 419079,
			spontaneous: 961988,
		},
		{
			id: 40,
			date: "25/09/2023",
			flexible: 134938,
			demanding: 12917,
			optimizer: 577628,
			spontaneous: 1355113,
		},
		{
			id: 41,
			date: "02/10/2023",
			flexible: 145035,
			demanding: 13885,
			optimizer: 610735,
			spontaneous: 1400852,
		},
		{
			id: 42,
			date: "09/10/2023",
			flexible: 139001,
			demanding: 12111,
			optimizer: 622560,
			spontaneous: 1482728,
		},
		{
			id: 43,
			date: "16/10/2023",
			flexible: 135801,
			demanding: 11945,
			optimizer: 609554,
			spontaneous: 1487333,
		},
		{
			id: 44,
			date: "23/10/2023",
			flexible: 138460,
			demanding: 12650,
			optimizer: 604081,
			spontaneous: 1448971,
		},
		{
			id: 45,
			date: "30/10/2023",
			flexible: 150829,
			demanding: 14205,
			optimizer: 661495,
			spontaneous: 1566488,
		},
		{
			id: 46,
			date: "06/11/2023",
			flexible: 128495,
			demanding: 11478,
			optimizer: 585580,
			spontaneous: 1453440,
		},
		{
			id: 47,
			date: "13/11/2023",
			flexible: 131430,
			demanding: 11258,
			optimizer: 598111,
			spontaneous: 1478300,
		},
		{
			id: 48,
			date: "20/11/2023",
			flexible: 130934,
			demanding: 11695,
			optimizer: 593265,
			spontaneous: 1461424,
		},
		{
			id: 49,
			date: "27/11/2023",
			flexible: 143697,
			demanding: 13644,
			optimizer: 626814,
			spontaneous: 1512095,
		},
		{
			id: 50,
			date: "04/12/2023",
			flexible: 120503,
			demanding: 10780,
			optimizer: 533000,
			spontaneous: 1297762,
		},
	],
}
